import apiFetch from '../apiFetch'

export default function (token, conditionType) {
  return apiFetch({ endPoint: `FunctionToAdd/${conditionType}/AllByLanguage`, method: 'GET', body: null, token: token })
}
